import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { AuthService } from './auth.service';

export const UserPermissionService = {
    getPermissions: async (userId: string, institutionId: string): Promise<string[]> => {
        const response = await axios.get(ENDPOINTS.USER.PERMISSIONS(userId, institutionId), {
            headers: AuthService.getAuthHeader(),
        });
        return response.data.permissionKeys ?? [];
    },

    setPermissions: async (userId: string, institutionId: string, keys: string[]): Promise<void> => {
        await axios.put(ENDPOINTS.USER.PERMISSIONS(userId, institutionId), keys, {
            headers: { ...AuthService.getAuthHeader(), 'Content-Type': 'application/json' },
        });
    },

    clearPermissions: async (userId: string, institutionId: string): Promise<void> => {
        await axios.delete(ENDPOINTS.USER.PERMISSIONS(userId, institutionId), {
            headers: AuthService.getAuthHeader(),
        });
    },
};
